import type { GridSortModel } from "@mui/x-data-grid/models";
import { defaultSelectSort } from "src/system/constants.ts";

export const getSelectSort = ({
  resource,
  sort,
}: {
  resource: string;
  sort?: GridSortModel;
}) => {
  if (sort) {
    return sort;
  }

  const defaultSort = defaultSelectSort[resource];

  if (defaultSort) {
    return [defaultSort] as GridSortModel;
  }
  return undefined;
};
